<template>
  <!--地址管理页面-->
  <tk-container :status="status">
    <!--头部-->
    <my-header slot="header">地址管理</my-header>
    <!--地址列表-->
    <div style="height: 10px;"></div>
    <div v-if="shippingAddress.length">
      <van-swipe-cell
        v-for="(s, index) in shippingAddress"
        :key="index"
      >
        <card
          :width="100"
          :height="70"
          class="p-12 shipping-list"
          style="border-radius: 0;"
          @click.native="selectedUsrAddress(s)"
        >
          <tk-flex middle between>
            <tk-flex middle column>
              <tk-flex middle class="font-bold">
                <div>{{s.name}}</div>
                <div class="m-l-24 m-t-2">{{s.phone}}</div>
              </tk-flex>
              <tk-flex class="m-t-8">
                <div class="default-tips" v-if="s.default === 'yes'">默认</div>
                <div class="font-13" :class="{'m-l-10': s.default === 'yes'}" style="color: #666;">{{$tkRegions.getFullName(s.region) + s.address}}</div>
              </tk-flex>
            </tk-flex>
            <tkui-button
              class="icon m-0"
              @click.native.stop="$push({path: '/itsMine/actionAddress', query: { id: s.objectId, type: 'editor' }})"
            >
              <tk-icon size="13" color="#999999">edit</tk-icon>
            </tkui-button>
          </tk-flex>
        </card>
        <template #right>
          <van-button @click="selectedAddress(s)" square text="删除" type="danger" class="delete-button" />
        </template>
      </van-swipe-cell>
    </div>
    <!--新增地址按钮-->
    <footer slot="footer">
      <div class="m-x-12 m-b-20" @click="$push({path: '/itsMine/actionAddress', query: { type: 'new' }})">
        <tkui-button class="primary block raised rounded">新增地址</tkui-button>
      </div>
    </footer>
    <!--确认删除弹框-->
    <tkui-dialog :show.sync="isShowDelete" center>
      <div class="subhead">
        您确定要删除收货地址吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowDelete = false">取消</button>
        <button class="tkui-dialog-button primary" :disabled="spinnerLoading" @click="deleteAddress">确定</button>
      </template>
    </tkui-dialog>
  </tk-container>
</template>

<script>
import { SwipeCell, Button } from 'vant'
export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button
  },
  data () {
    return {
      status: 'loading', // 页面状态
      isShowDelete: false, // 删除弹框
      spinnerLoading: false, // 删除按钮状态
      deleteShipping: null, // 删除的数据
      shippingAddress: [] // 收货地址数据
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/4/15
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        let res = await this.$tkParse.getList('/classes/shippingAddress', {
          params: {
            limit: 10000,
            order: `-createdAt`,
            where: {
              user: this.userInfo.objectId
            }
          }
        })
        if (res.length) {
          let defaultIndex = res.findIndex(s => { return s.default === 'yes' })
          if (defaultIndex !== -1) {
            let copyObj = this.$tkHelper.deepClone(res[defaultIndex])
            res.splice(defaultIndex, 1)
            res.unshift(copyObj)
          }
          this.shippingAddress = res
        } else {
          this.shippingAddress = []
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 选择用户收货地址
    * @date: 2020/4/28
    */
    selectedUsrAddress (s) {
      if (!this.$route.query.isSelected) { return }
      this.$store.commit('setAddressId', s.objectId)
      this.$back()
    },
    selectedAddress (s) {
      this.deleteShipping = s
      this.isShowDelete = true
    },
    /**
     * @Description: 删除地址
     * @author xiaozan
     * @date 2020/5/5
     */
    async deleteAddress () {
      this.spinnerLoading = true
      this.isShowDelete = false
      let s = this.deleteShipping
      let res = await this.$tkParse.getData(`/classes/shippingAddress/${s.objectId}`)
      if (res.default === 'yes') {
        this.spinnerLoading = false
        return this.$tkGlobal.toast.add('您不能删除默认地址')
      }
      await this.$tkParse.put(`/classes/shippingAddress/${s.objectId}`, {
        isDeleted: true
      }).catch(e => {
        this.spinnerLoading = false
        throw this.$tkGlobal.toast.add('删除地址失败')
      })
      await this.getInit()
      await this.$tkHelper.sleep(500)
      this.spinnerLoading = false
      this.$tkGlobal.toast.add('删除地址成功')
    }
  },
  async hasFlash (flash) {
    if (flash) { await this.getInit() }
    this.$forceUpdate()
  }
}
</script>

<style scoped lang="scss">
  /*默认提示样式*/
  .default-tips {
    min-width: 41px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    background: rgba(212, 28, 22, 1);
    border-radius: 8px;
    font-size: 11px;
    color: rgba(255, 255, 255, 1);
  }
  .shipping-list {
    border-bottom: 1px solid #f5f5f5;
  }
  /*删除样式*/
  .delete-button {
    height: 100%;
  }
</style>
